import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["triggerRef"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @jsxRuntime classic */
import React, { lazy, Suspense, useCallback } from 'react';
import { createRecommendationContextExtensions } from '@atlassiansox/cross-flow-extensions';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import { Journeys } from '@atlassian/app-provisioning';
import { formatStringMessage } from '../../../utils/formatMessage';
import { getExperimentCohort, getRecommendationDescription } from '../app-recommendations-list/experiment';
import { AppLogo } from './app-logo';
import { getExperimentValues } from './experiment';
var AppRecommendationMenu = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_app-recommendation-menu" */'../app-recommendation-menu');
});
var recommendationStyles = xcss({
  display: 'flex',
  width: '100%',
  justifyItems: 'stretch',
  justifyContent: 'flex-end',
  gap: 'space.025',
  height: '48px',
  alignItems: 'center'
});
var commonButtonStyles = xcss({
  borderRadius: 'border.radius',
  border: 'none',
  display: 'flex',
  backgroundColor: 'color.background.neutral.subtle',
  minWidth: '0',
  height: "var(--ds-space-600, 48px)",
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle.pressed'
  }
});
var recommendationButtonStyles = xcss({
  textAlign: 'left',
  flexGrow: 1,
  paddingBlock: 'space.050',
  paddingInline: 'space.100',
  lineHeight: '18px',
  alignItems: 'stretch',
  color: 'color.text'
});
var menuTriggerButtonStyles = xcss({
  width: "var(--ds-space-600, 48px)",
  padding: 'space.0',
  alignItems: 'center',
  justifyContent: 'center'
});
var recommendationBodyIconStyles = xcss({
  marginRight: 'space.100',
  display: 'flex',
  alignItems: 'center'
});
var recommendationBodyContentStyles = xcss({
  overflow: 'hidden',
  fontWeight: 400,
  display: 'flex',
  flexDirection: 'column'
});
var titleStyles = xcss({
  fontSize: "var(--ds-font-body, 14px)",
  fontWeight: 400,
  marginTop: 'space.025',
  minWidth: '0',
  lineHeight: '16px'
});
var tagLineStyles = xcss({
  marginTop: 'space.050',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  color: 'color.text.subtlest',
  fontSize: '11px',
  lineHeight: '16px'
});
var tblzSwitcherTagLineStyles = xcss({
  color: 'color.text.subtlest',
  fontSize: '12px'
});
export var AppRecommendation = function AppRecommendation(_ref) {
  var actionBus = _ref.actionBus,
    name = _ref.name,
    description = _ref.description,
    _ref$journey = _ref.journey,
    journey = _ref$journey === void 0 ? Journeys.DECIDE : _ref$journey,
    productId = _ref.productId,
    logo = _ref.logo,
    appProvisioning = _ref.appProvisioning,
    mutate = _ref.mutate,
    reasons = _ref.reasons,
    context = _ref.context,
    adControlsMenuLabel = _ref.adControlsMenuLabel,
    adControlsMenuNotInterested = _ref.adControlsMenuNotInterested,
    adControlsMenuWhyAmISeeingThis = _ref.adControlsMenuWhyAmISeeingThis,
    recommendationReasonsModalTitle = _ref.recommendationReasonsModalTitle,
    recommendationReasonsModalExplanation = _ref.recommendationReasonsModalExplanation,
    recommendationReasonsModalPrivacyPolicyLinkText = _ref.recommendationReasonsModalPrivacyPolicyLinkText,
    recommendationReasonsModalPrivacyPolicyLinkHref = _ref.recommendationReasonsModalPrivacyPolicyLinkHref,
    recommendationReasonsModalAcceptButton = _ref.recommendationReasonsModalAcceptButton;
  var tblzSwitcherRoleBasedExperimentCohort = getExperimentCohort(context);
  var handleAppProvisioning = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(journeyOverride) {
      var completionStatus;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return appProvisioning({
              sourceComponent: 'atlassian-switcher',
              sourceContext: 'AppRecommendation',
              productId: productId,
              journey: journeyOverride !== null && journeyOverride !== void 0 ? journeyOverride : journey,
              extraAnalyticsAttributes: {
                tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
              },
              extensions: context.sessionId ? createRecommendationContextExtensions({
                entityId: productId,
                recommendationSessionId: context.sessionId
              }) : undefined
            });
          case 3:
            completionStatus = _context.sent;
            if ((completionStatus === null || completionStatus === void 0 ? void 0 : completionStatus.success) === true) {
              mutate(function (currentConfiguration) {
                var _currentConfiguration;
                return _objectSpread(_objectSpread({}, currentConfiguration), {}, {
                  apps: (_currentConfiguration = currentConfiguration.apps) === null || _currentConfiguration === void 0 ? void 0 : _currentConfiguration.filter(function (app) {
                    return app.productId !== productId;
                  })
                });
              });
            }
            _context.next = 9;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [appProvisioning, productId, journey, context.sessionId, tblzSwitcherRoleBasedExperimentCohort, mutate]);
  var MenuTrigger = function MenuTrigger(_ref3) {
    var triggerRef = _ref3.triggerRef,
      triggerProps = _objectWithoutProperties(_ref3, _excluded);
    return /*#__PURE__*/React.createElement(Pressable, _extends({
      "aria-label": formatStringMessage(adControlsMenuLabel, {
        productName: name
      })
    }, triggerProps, {
      xcss: [commonButtonStyles, menuTriggerButtonStyles],
      ref: triggerRef
    }), /*#__PURE__*/React.createElement(MoreIcon, {
      primaryColor: "var(--ds-icon, #44546F)",
      label: "",
      size: "small"
    }));
  };
  var messages = {
    recommendationReasonsModalTitle: recommendationReasonsModalTitle,
    recommendationReasonsModalExplanation: recommendationReasonsModalExplanation,
    recommendationReasonsModalPrivacyPolicyLinkText: recommendationReasonsModalPrivacyPolicyLinkText,
    recommendationReasonsModalPrivacyPolicyLinkHref: recommendationReasonsModalPrivacyPolicyLinkHref,
    recommendationReasonsModalAcceptButton: recommendationReasonsModalAcceptButton
  };
  return /*#__PURE__*/React.createElement(Box, {
    xcss: recommendationStyles
  }, /*#__PURE__*/React.createElement(Pressable, {
    onClick: function onClick() {
      var experimentValues = getExperimentValues(context, productId);
      handleAppProvisioning(experimentValues === null || experimentValues === void 0 ? void 0 : experimentValues.journeyOverride);
      actionBus === null || actionBus === void 0 || actionBus.dispatch('CLICK_APP_RECOMMENDATION', {
        productId: productId,
        action: {
          action: 'clicked',
          actionSubject: 'listItem',
          actionSubjectId: 'product'
        },
        source: 'atlassianSwitcherDiscoverProductsSection',
        skipBenefitsPageExperimentCohort: experimentValues === null || experimentValues === void 0 ? void 0 : experimentValues.cohort,
        tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
      });
    },
    xcss: [commonButtonStyles, recommendationButtonStyles]
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: recommendationBodyIconStyles
  }, /*#__PURE__*/React.createElement(AppLogo, {
    src: logo,
    tblzSwitcherRoleBasedExperimentCohort: tblzSwitcherRoleBasedExperimentCohort
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: recommendationBodyContentStyles
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: titleStyles
  }, name), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    xcss: [tagLineStyles, tblzSwitcherRoleBasedExperimentCohort === 'experiment' && tblzSwitcherTagLineStyles]
  }, getRecommendationDescription(description, productId, tblzSwitcherRoleBasedExperimentCohort)))), /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      xcss: menuTriggerButtonStyles
    })
  }, /*#__PURE__*/React.createElement(AppRecommendationMenu, _extends({}, messages, {
    actionBus: actionBus,
    context: context,
    mutate: mutate,
    name: name,
    reasons: reasons,
    menu: [{
      title: adControlsMenuNotInterested,
      action: {
        actionType: 'DISMISS'
      }
    }, {
      title: adControlsMenuWhyAmISeeingThis,
      action: {
        actionType: 'REASON'
      }
    }],
    productId: productId,
    menuTrigger: MenuTrigger
  }))));
};